import React, {forwardRef} from "react";
import {APP_WEB} from "../../../../../src/electron_interactive";
import {HOVER_CIRCLE_ELEMENT_SIZE} from "../../../../../src/Const";

export const HoveredElementCircle = forwardRef((props:{state:any,el:any}, ref) => {
    const getHoveredElementSize = ()=>{
        return 20/props.state.zoom.value;
    }
    return(
        (APP_WEB || props.state.hoveredElement?.element?.width < HOVER_CIRCLE_ELEMENT_SIZE || props.state.hoveredElement?.element?.height < HOVER_CIRCLE_ELEMENT_SIZE)?<></>:
        <>
            {
                props.state.hoveredElement?.element?.id == props.el?.id && props.state.hoveredElement?.direction == 'left' &&
                <div style={{width:getHoveredElementSize()+'px',height:getHoveredElementSize()+'px',borderRadius:'50%',left:-getHoveredElementSize()/2,top:`calc(50% - ${getHoveredElementSize()/2}px)`}} className={'hovered-element'}></div>
            }
            {
                props.state.hoveredElement?.element?.id == props.el?.id && props.state.hoveredElement?.direction == 'top' &&
                <div style={{width:getHoveredElementSize()+'px',height:getHoveredElementSize()+'px',borderRadius:'50%',left:`calc(50% - ${getHoveredElementSize()/2}px)`,top:-getHoveredElementSize()/2}} className={'hovered-element top'}></div>
            }
            {
                props.state.hoveredElement?.element?.id == props.el?.id && props.state.hoveredElement?.direction == 'right' &&
                <div style={{width:getHoveredElementSize()+'px',height:getHoveredElementSize()+'px',borderRadius:'50%',right:-getHoveredElementSize()/2,top:`calc(50% - ${getHoveredElementSize()/2}px)`}} className={'hovered-element right'}></div>
            }
            {
                props.state.hoveredElement?.element?.id == props.el?.id && props.state.hoveredElement?.direction == 'bottom' &&
                <div style={{width:getHoveredElementSize()+'px',height:getHoveredElementSize()+'px',borderRadius:'50%',left:`calc(50% - ${getHoveredElementSize()/2}px)`,bottom:-getHoveredElementSize()/2}} className={'hovered-element bottom'}></div>
            }
        </>
    )
})